<template>
      <div class="">
      <ol class="breadcrumb">
          <li class="black">1. Collection</li>
          <li :class="[$store.state.current_step > 2 ? 'black':'gray',{StepActive:$store.state.current_step==2}]">2. Materials</li>
          <li :class="[$store.state.current_step > 3 ? 'black':'gray',{StepActive:$store.state.current_step==3}]">3. Format</li>
          <li :class="[$store.state.current_step > 4 ? 'black':'gray',{StepActive:$store.state.current_step==4}]">4. Product</li>
          <li :class="[$store.state.current_step > 5 ? 'black':'gray',{StepActive:$store.state.current_step==5}]">5. Style</li>
          <li :class="[$store.state.current_step > 6 ? 'black':'gray',{StepActive:$store.state.current_step==6}]">6. Engraving</li>
          <li :class="[$store.state.current_step > 7 ? 'black':'gray',{StepActive:$store.state.current_step==7}]">7. Configuration</li>
          <li :class="[$store.state.current_step > 8 ? 'black':'gray',{StepActive:$store.state.current_step==8}]">8. Create</li>
          

          <a class="closeButton" @click="open"><i class="el-icon-close" ></i></a>

        </ol>
      </div>
</template>
<script>
export default {
    methods: {
      open() {
        this.$confirm('Are you sure you want to leave?', 'Warning', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          this.$router.push({path: '/collection'});

        })
        
      }
    }
  } 

</script>